module.exports = __webpack_public_path__ + "img/priority-active.8fdfbc7e.svg";